// extracted by mini-css-extract-plugin
module.exports = {"pageDescription":"School-module--pageDescription--3X7wQ"};